module.exports = __webpack_public_path__ + "static/img/layer5.706b960d.png";